import { CircularProgress, Stack, Typography } from "@mui/material";
import { JobDescriptionDialog } from "Components/JobsTs/JobDescriptionDialog";
import jobDescFill from 'assets/Images/job_desc_fill.png';
import { useAppSelector } from "helpers/hooks";
import { useState } from "react";
import { ShGreenBtn } from "shared/SharedStyles/ShInputs";
import { ShPaper } from "shared/SharedStyles/ShSurfaces";

export const JobDetailsPanel = () => {

    const [isJobDescriptionOpen, setIsJobDescriptionOpen] = useState<boolean>(false);
    const { jobDescription, getJobDescriptionResponse, getJobDescriptionStatus } = useAppSelector(state => state.employer.jobInfo);

    return (<>
        <ShPaper variant='outlined'>
            {
                getJobDescriptionStatus === 'pending' ?
                    <>
                        <CircularProgress />
                        <Typography variant="body2">Loading Job details...</Typography>
                    </> : <>
                        <Stack rowGap={{ xs: 1, sm: 2, md: 2, lg: 2 }} padding={{ xs: 2, sm: 3, md: 4, lg: 4 }}>
                            {jobDescription?.company_alias &&
                                <Stack>
                                    <Typography variant='body1' fontWeight={600}>Company</Typography>
                                    <Typography variant='body2'>{jobDescription?.company_alias}</Typography>
                                </Stack>}
                            {jobDescription?.name &&
                                <Stack>
                                    <Typography variant='body1' fontWeight={600}>Job Title</Typography>
                                    <Typography variant='body2'>{jobDescription?.name}</Typography>
                                </Stack>
                            }
                            {jobDescription?.city &&
                                <Stack>
                                    <Typography variant='body1' fontWeight={600}>Job Location</Typography>
                                    <Typography variant='body2'>{jobDescription?.city}</Typography>
                                </Stack>}
                            <img src={jobDescFill} alt="jobDescFill" />
                            <ShGreenBtn onClick={() => setIsJobDescriptionOpen(true)}>View job description</ShGreenBtn>
                            {/* Job description dialog. */}
                            <JobDescriptionDialog isJobDescOpen={isJobDescriptionOpen} setIsJobDescOpen={setIsJobDescriptionOpen}
                                jobDescApiResponse={getJobDescriptionResponse} jobDescApiStatus={getJobDescriptionStatus}
                                jobDescription={jobDescription?.description} jobName={jobDescription?.name} />
                        </Stack>
                    </>
            }
        </ShPaper>
    </>)
}